import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Router,
  Outlet,
  Navigate,
  useLocation,
} from "react-router-dom";
import "./App.css";
import "./global.css";
import { SpeedInsights } from "@vercel/speed-insights/react";
import NavBar from "./common/NavBar";
import Home from "./view/Home";
import About from "./view/About";
import Career from "./view/Career";
import Contact from "./view/Contact";

import Configuratore from "./view/Configuratore";
import RedirectPage from "./view/RedirectPage";
import Footer from "./common/Footer";
import AOS from "aos";
import ReactGA from 'react-ga4';
import { initGA, logPageView } from './types/ga'; // Adjust the import path accordingly
import GAListener from './components/GAListener'; // Adjust the import path accordingly

//commento
import { Analytics } from "@vercel/analytics/react";

import { useEffect } from "react";

//import "vanilla-cookieconsent/dist/cookieconsent.css";
//import * as CookieConsent from "vanilla-cookieconsent";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Product_SARA from "./view/Product_SARA";
import ScrollToAnchor from "./ScrollToAnchor";
import NewsPage from "./view/NewsPage";

import NewsDetail from "./view/NewsDetail";
import ConfiguratoreUI from "./common/configuratore/ConfiguratoreUI";
import Holly from "./view/Holly";
import Mara from "./view/Mara";
import Product_PAVEL from "./view/Product_PAVEL";
import Product_KIMBALL from "./view/Product_KIMBALL";
import SuccessStories from "./common/successStory/SuccessStories";
import SuccessStorySingle from "./common/successStory/SuccessStorySingle";
import SuccessStoryCard from "./common/successStory/SuccessStoryCard";



function ElmoCookieBanner() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://bnr.elmobot.eu/VctPlAIHIHPfxKkydi1qe/en.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null; // Oppure puoi renderizzare un placeholder se necessario
}









function Background() {
  const location = useLocation();


  if (
    location.pathname === "/products/pavel" ||
    location.pathname.startsWith("/products/pavel/") ||
    location.pathname === "/products/kimball" ||
    location.pathname.startsWith("/products/kimball/")
  ) {
    return (
        <div
            className="h-[92rem] absolute top-0 left-0 w-full bg-cover bg-bottom opacity-100 pointer-events-none mt-20"
            style={{ backgroundImage: "url('/products/Pavel/BGPAVEL2.svg')" }}
        />
    );
  }

  return location.pathname !== "/news" &&
    !location.pathname.startsWith("/news/") && location.pathname !== "/products/sara" && !location.pathname.startsWith("/success-stories") && !location.pathname.startsWith("/products/sara") ? (
    <div className="h-[92rem] absolute top-0 left-0 w-full bg-[url('/public/bg.svg')] bg-cover bg-bottom opacity-75  pointer-events-none mt-20 "></div>
  ) : (
    <div></div>
  );
}

function ExternalRedirect({ to }: { to: string }) {
  useEffect(() => {
    window.open(to, "_blank", "noopener,noreferrer");
    setTimeout(() => window.history.back(), 100);
  }, [to]);
  return null;
}
function App() {
  AOS.init();

  useEffect(() => {
      initGA(process.env.REACT_APP_ANALYTICS);

  }, []);


  return (
    <div className="bg-black overflow-x-hidden">
      <BrowserRouter>
      
      <ElmoCookieBanner/>
        <NavBar />
        <div className="bg-black">
          <Background/>
          <ScrollToAnchor/>
          <GAListener data-cookiecategory="analytics">
          <Routes>

            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="home" element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="products/sara" element={<Product_SARA />} />
            <Route path="products/holly" element={<Holly />} />
            <Route path="products/mara" element={<Mara />} />
            <Route path="products/pavel" element={<Product_PAVEL />} />
            <Route path="products/kimball" element={<Product_KIMBALL />} />
            <Route path="/success-stories"     element={<SuccessStories />}     />

            <Route path="/success-stories/:id" element={<SuccessStoryCard />} /> 

            <Route path="contact" element={<Contact />} />

            {/*<Route path="careers" element={<Career />} />*/}
            {/*<Route path="careers" element={<Navigate to="https://careers.revolvspace.com/" replace />} />*/}
            <Route
                path="careers"
                element={<ExternalRedirect to="https://careers.revolvspace.com/" />}
            />
            <Route path="news/:name/:id" element={<NewsDetail />} />
            <Route path="configuratore" element={<ConfiguratoreUI />} />
            <Route path="news" element={<NewsPage />} />
            <Route path="/redirect" element={<RedirectPage />} />
          </Routes>
          </GAListener>
        </div>
        <Footer />
      </BrowserRouter>
      <Analytics data-cookiecategory="analytics"/>
      <SpeedInsights data-cookiecategory="analytics" />
    </div>
  );
}
export default App;
